<template>
    <div class="MyBusinessCard">
        <div>
            <div class="followTitle">我的服务人</div>
            <div class="superiorImg">
                <img :src="imageUrl" alt="" class="superiorImgPic">
            </div>
            <div class="tips between">
                <span>长按识别或保存二维码</span>
                <span class="red" @click="onLook">放大查看图片</span>
            </div>
        </div>
        <van-overlay :show="isLoading">
            <div class="wrapper">
                <loading v-if="isLoading == true"></loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>

import {
    CellGroup, Toast, Dialog, Notify, ImagePreview,Overlay
} from "vant";
import loading from "../loading/loading";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            isLoading: true, //loading状态
            close: false, //关闭弹窗
            imageUrl: '',
            status: false,
            fileList: [],
            pictureList: [],
            
        };
    },
    components: {
        [CellGroup.name]: CellGroup,
        [Toast.name]: Toast,
        [Dialog.Component.name]: Dialog.Component,
        [Notify.name]: Notify,
        [ImagePreview.Component.name]: ImagePreview.Component,
        [Overlay.name]: Overlay,
        loading
    },
    props: {
        msgSuperior: {
            type: String,
            default: "这是默认值"
        }
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    mounted() {
        console.log(this.msgSuperior, "this.msgSuperior")
        this.imageUrl = this.msgSuperior
        setTimeout(() => {
            this.isLoading =false
        }, 700);
    },
    methods: {
        // 确定
        onConfirm() {
            this.close = false
        },
        onLook() {
            ImagePreview({
                images: [
                    this.imageUrl
                ],
                closeable: true,
                showIndex:false
            });
        }
    },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.MyBusinessCard {
    width: 263px;
    max-height: 509px;
    padding: 16px;

    .followTitle {
        font-size: 16px;
        text-align: center;
        font-weight: 600;
        width: 100%;
        text-align: center;
        padding-bottom: 16px;
    }

    // 提示
    .tips {
        margin-top: 16px;
        color: #999999;
        font-size: 12px;
    }

    .noOrders {
        padding-top: 16vw;
    }

    // 按钮样式
    .bottom {
        margin: auto;

        .bottomBtn {
            width: 100%;
            height: 40px;
            background: #ee0a24;
            border: 0;
            border-radius: 4px;
            color: #fff;
            font-size: 4vw;
        }
    }

    // 上传名片样式

    .superiorImg {
        display: block;
        width: 100%;
        height: 100%;
        max-width: 263px;
        max-height: 350px;
        margin: auto;
    }
}
</style>
  